module.exports = __webpack_public_path__ + "img/img-syxd.2864b46f.png";